import { useState } from 'react'

import { GAME_TYPE } from 'constants/enums/GameTypeEnum'

import { PostIdea, ViewMasterImageRequest } from './ideaModels'

type Conversation = {
	content: string
	role: string
}

export function ViewMasterModel() {
	const [authorIdeation, setAuthorIdeation] = useState<string>('')
	const [companyName, setCompanyName] = useState<string>('')
	const [companyProblem, setCompanyProblem] = useState<string>('')
	const [currentPrompts, setCurrentPrompts] = useState<string[]>(
		Array(4).fill('')
	)
	const [responseConversation, setResponseConversation] = useState<
		Conversation[]
	>([])
	const [currentResponses, setCurrentResponses] = useState<string>('')
	const [currentResponse, setCurrentResponse] = useState<string>('')
	const [gameId, setGameId] = useState<string | null>(null)
	const [imageData, setImageData] = useState<string | null>(null)
	const [termsAgreed, setTermsAgreed] = useState(false)

	const generatePromptsDisabled = () => {
		if (!companyName || !companyProblem) return true
		else return false
	}

	const submitIdeasDisabled = () => {
		if (
			generatePromptsDisabled() ||
			authorIdeation.length === 0 ||
			authorIdeation === '<p></p>' ||
			(gameId && !termsAgreed)
		)
			return true
		else return false
	}

	const reset = () => {
		setResponseConversation([])
		setAuthorIdeation('')
		setCurrentResponses('')
		setImageData(null)
	}

	const imageToJSON = (): ViewMasterImageRequest => ({
		companyName,
		innovationConcept: companyProblem,
	})

	const postObject = (): PostIdea => ({
		gameId: gameId ?? undefined,
		gameTypeId: GAME_TYPE.VIEW_MASTER.value,
		innovationCompany: companyName,
		innovationTopicManual: companyProblem,
		authorIdeation,
	})

	return {
		companyName,
		companyProblem,
		setCompanyName,
		setCompanyProblem,
		currentResponse,
		setCurrentResponse,
		setGameId,
		authorIdeation,
		setAuthorIdeation,
		currentPrompts,
		setCurrentPrompts,
		gameId,
		termsAgreed,
		setTermsAgreed,
		generatePromptsDisabled,
		submitIdeasDisabled,
		reset,
		responseConversation,
		setResponseConversation,
		currentResponses,
		setCurrentResponses,
		imageData,
		setImageData,
		imageToJSON,
		postObject,
	}
}
